// TODO: Modal Dictionary

import "./index.scss";
import { Button } from "@wise-emotions/react-button";
import { CfSmsProps } from "../types";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import {
  GeneralMediumCheck2,
  GeneralMediumClose,
} from "@wise-emotions/react-icons";
import { Input } from "@wise-emotions/react-input";
import { getIdCaptcha } from "../utils/captcha";
import { logDebug } from "helpers/generic";
import { stringIsNumber } from "utilities/utils";
import AreaCodeSelect from "components/AreaCodeSelect";
import IconWrap from "components/Icon/IconWrap";
import Loader from "components/Loader";
import React, { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import loadGoogleReCaptcha from "utilities/loadGoogleReCaptcha";
import parse from "html-react-parser";

const CfSms = (props: CfSmsProps) => {
  const {
    children,
    errorSendMessage,
    hideForm,
    hideFormMobile,
    image,
    inputPhonePalcehoder,
    inputPhoneValidationErrorMessege,
    textTop,
    textForm,
    sendButtonLabel,
    successSendMessage,
    smsTemplateId,
    // urlApiSms, use static api url for sms
  } = props;

  const { idCaptcha, domainProd } = getIdCaptcha(
    process.env.GATSBY_RECAPTCHA_SMS_PROD,
    process.env.GATSBY_RECAPTCHA_SMS_TEST,
  );

  const imageSms = image?.[0].imageDesktop.file.url ?? false;
  const inputPhoneLabel = inputPhonePalcehoder?.[0].text.text ?? "";
  const inputPhoneValidationErrorMessegeLabel =
    inputPhoneValidationErrorMessege?.[0].text.text ?? "";
  const textTopSms = parse(textTop?.textTop ?? "");
  const textFormSms = parse(textForm?.textForm ?? "");
  const sendButton = sendButtonLabel?.[0].text.text ?? "";
  const successSendMessageSms = successSendMessage?.successSendMessage ?? "";
  const errorSendMessageSms = errorSendMessage?.errorSendMessage ?? "";
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState<
    { status: boolean; message: string } | undefined
  >(undefined);

  const methods = useForm();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const onSubmit = (data: FieldValues) => {
    setLoader(true);

    window.grecaptcha.ready(() => {
      try {
        window.grecaptcha
          .execute(idCaptcha, { action: "submit_sms" })
          .then((token) => {
            axios({
              method: "post",

              url: domainProd
                ? "https://ws.telepass.com/api/v1/sms"
                : "https://ws-test.telepass.com/api/v1/sms",

              data: {
                template: smsTemplateId,
                phoneNumber: data.areaCode + data.phoneNumber,
                captchaToken: token,
              },
            })
              .then((res: AxiosResponse) => {
                // handle success
                setLoader(false);
                setResponseMessage({
                  status: true,
                  message: successSendMessageSms,
                });
                // return response.data;
              })
              .catch((error) => {
                logDebug(error);
                setLoader(false);
                setResponseMessage({
                  status: false,
                  message: errorSendMessageSms,
                });
              });
          });
      } catch (error) {
        setLoader(false);
        setResponseMessage({
          status: false,
          message: errorSendMessageSms,
        });
        throw error;
      }
    });
  };

  const style = { backgroundImage: `url(${imageSms})` };

  useEffect(() => {
    if (idCaptcha) {
      loadGoogleReCaptcha(idCaptcha, () => {});
    }
  }, [idCaptcha]);

  return (
    <div className="Sms">
      <div className="Sms__image" style={style} />
      <div className="Sms__content">
        {loader && (
          <div className="Sms__content__loader">
            <Loader loading={loader} />
          </div>
        )}
        {!responseMessage ? (
          <>
            <div className="Sms__textTop">{textTopSms}</div>
            {!hideForm && idCaptcha && (
              <>
                <div
                  className={`Sms__textForm ${
                    hideFormMobile ? "Sms__textForm--hideInMobile" : ""
                  }`}
                >
                  {textFormSms}
                </div>
                <FormProvider {...methods}>
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={`Sms__form ${
                      hideFormMobile ? "Sms__form--hideInMobile" : ""
                    }`}
                  >
                    <fieldset className="Sms__fieldset">
                      <div className="Sms__phone">
                        <div className="Sms__phone__area-code">
                          {/* TODO: add transaltion in lable */}
                          <AreaCodeSelect label="Prefisso" name="areaCode" />
                        </div>
                        <div className="Sms__phone__input">
                          <Input
                            id="phone-number"
                            valid={!errors.phoneNumber}
                            helperText={
                              errors.phoneNumber &&
                              inputPhoneValidationErrorMessegeLabel
                            }
                            inputMode="tel"
                            type="tel"
                            label={inputPhoneLabel}
                            {...register("phoneNumber", {
                              validate: (value) => stringIsNumber(value, 6, 25),
                            })}
                          />
                        </div>
                      </div>
                    </fieldset>
                    {/* TODO: check if class send-sms is used for tranking event  */}
                    <div
                      className="send-sms"
                      data-tracking="btn-send-sms"
                      data-position="pop_up"
                    >
                      <Button variant="default" type="submit">
                        {sendButton}
                      </Button>
                    </div>
                  </form>
                </FormProvider>
              </>
            )}
          </>
        ) : (
          <div className="Sms__response">
            <div
              className={`Sms__response__icon ${
                responseMessage.status ? "bg--success" : "bg--error"
              }`}
            >
              {responseMessage.status ? (
                <IconWrap>
                  <GeneralMediumCheck2 />
                </IconWrap>
              ) : (
                <IconWrap>
                  <GeneralMediumClose />
                </IconWrap>
              )}
            </div>
            <div className="Sms__response__message">
              {parse(responseMessage.message)}
            </div>
          </div>
        )}
        <div className="Sms__textBottom">{children}</div>
      </div>
    </div>
  );
};

export default CfSms;
